import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import styles from './Chart2.module.css'; // Import the CSS module


function Chart2(isDarkMode) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const chartOptions = {
    chart: {
      type: 'donut',
    },
    labels: ['ADX', 'NasdaqDubai', 'DFM', 'RAC Finance'],
    dataLabels: {
      enabled: true,
    },
    legend: {
      position: 'right',
      offsetY: 0,
      height: 230,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Sales',
              formatter: () => '230,900' // Display a static total value
            }
          }
        }
      }
    },
    colors: ['#00E396', '#FEB019', '#FF4560', '#775DD0']
  };

  const series = [4260, 3970, 3454, 2390]; // Replace with actual data

  // Function to handle selection from the dropdown
  const handleSelection = (timeRange) => {
    // Logic to update chart data based on the selected time range
    console.log(`Selected time range: ${timeRange}`);
    // ... Update your chart data here ...
    setDropdownOpen(false);
  };

  return (
    <div className={`${styles.first}`}>
        <div className={`${styles.second}`}>
      <h3>Stocks Distribution</h3>
      <div style={{ position: 'relative' }}>
        <button onClick={() => setDropdownOpen(!dropdownOpen)} className={`${styles.third}`}>
          Last 1 Month ▼
        </button>
        {dropdownOpen && (
          <div className={`${styles.four}`} style={{
            backgroundColor: isDarkMode ? '#000' : 'white',
          }}>
            <div className={`${styles.five}`} onClick={() => handleSelection('1 Month')}>Last 1 Month</div>
            <div className={`${styles.five}`} onClick={() => handleSelection('3 Months')}>Last 3 Months</div>
            <div className={`${styles.five}`} onClick={() => handleSelection('6 Months')}>Last 6 Months</div>
            <div className={`${styles.five}`} onClick={() => handleSelection('1 Year')}>Last 1 Year</div>
          </div>
        )}
      </div>
      </div>
      <div className={`${styles.six}`}>
        <Chart options={chartOptions} series={series} type="donut" height="350" />
      </div>
    </div>
  );
}

export default Chart2;
